import React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
} from "@mui/material";
import type { TableCellType, TableSortType } from "./index";

type EnhancedTableHeadProps = {
  cells: Array<TableCellType>;
  order: TableSortType;
  orderBy: string;
  numSelected: number;
  rowCount: number;
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRequestSort: (event: any, property: string) => void;
  withCheckbox?: boolean;
};

const EnhancedTableHead = ({
  cells,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  withCheckbox,
}: EnhancedTableHeadProps) => {

  const createSortHandler = (accessor: string) => (event: any) => {
    onRequestSort(event, accessor);
  };

  return (
    <TableHead>
      <TableRow>
        {withCheckbox && !onSelectAllClick && <TableCell />}
        {onSelectAllClick && (
          <TableCell component="th" padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all" }}
            />
          </TableCell>
        )}
        {cells.map((cell, i) => {
          const accessor = cell.customSortAccessor || cell.accessor;
          return (
            <TableCell
              key={`${i}-${cell.accessor ?? i}`}
              align={cell.align}
              className={cell.className}
              padding={i === 0 && onSelectAllClick ? "none" : "normal"}
              sortDirection={orderBy === accessor ? order : false}
              width={cell.width}
              component="th"
            >
              {cell.noSort ? (
                cell.label
              ) : (
                <TableSortLabel
                  active={orderBy === accessor}
                  direction={orderBy === accessor ? order : "asc"}
                  onClick={createSortHandler(accessor)}
                >
                  {cell.label}
                </TableSortLabel>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
